import React from "react";

const NoIcon = () => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="32" height="32" rx="4" fill="#EAECF0" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.4569 9V9.00546C12.4105 9.00314 12.3641 9.00314 12.3177 9.00546C12.0638 9.01957 11.8187 9.10279 11.6087 9.24612C11.3987 9.38945 11.2318 9.58744 11.1262 9.8187C11.0205 10.05 10.9801 10.3057 11.0092 10.5583C11.0383 10.8109 11.1359 11.0507 11.2914 11.2518L14.8452 15.9902L11.2914 20.7367C11.0695 21.0332 10.9745 21.4056 11.0272 21.7721C11.08 22.1386 11.2761 22.4692 11.5726 22.6911C11.869 22.9129 12.2414 23.008 12.6079 22.9552C12.9744 22.9025 13.305 22.7064 13.5269 22.4099L16.5893 18.3239L19.6518 22.4099C19.7595 22.5622 19.8966 22.6914 20.055 22.7899C20.2135 22.8883 20.3901 22.954 20.5743 22.983C20.7586 23.012 20.9468 23.0038 21.1279 22.9588C21.3089 22.9139 21.4791 22.8331 21.6284 22.7212C21.7776 22.6093 21.903 22.4687 21.997 22.3076C22.0909 22.1464 22.1517 21.9681 22.1756 21.7831C22.1994 21.5981 22.186 21.4102 22.136 21.2304C22.086 21.0507 22.0005 20.8829 21.8845 20.7367L18.3335 15.9902L21.8845 11.2518C22.0501 11.0384 22.1502 10.7815 22.1726 10.5123C22.1951 10.243 22.1388 9.97312 22.0108 9.73524C21.8827 9.49737 21.6884 9.30178 21.4513 9.17224C21.2143 9.04269 20.9447 8.98475 20.6754 9.00546C20.4734 9.02096 20.2772 9.08026 20.1004 9.17924C19.9236 9.27823 19.7706 9.41452 19.6518 9.57865L16.5893 13.6647L13.5269 9.57865C13.4038 9.40767 13.2436 9.26679 13.0583 9.16658C12.873 9.06636 12.6674 9.00941 12.4569 9Z"
      fill="#7D8597"
    />
  </svg>
);

export default NoIcon;
